define('home/collections/VotersUserCollection',[
    'core/UniqueModel',
    'home/models/User',
    'core/collections/VotersUserCollection',
], function (
    UniqueModel,
    User,
    VotersUserCollection
) {
    'use strict';

    return VotersUserCollection.extend({
        // Bind User model with Unique Model
        model: UniqueModel.boundModel(User),

        parse: function (response) {
            return response.response;
        },
    });
});

